export const ROOT_TENANT = 'sys'
export const ADMIN_CONSOLE_CLIENT_ID = '-niomon-admin-console'
export const ADMIN_CONSOLE_TENANT = 'sys'
export const DITTO_TENANT = 'ditto'
export const ADMIN_CONSOLE_VISIT_URL_KEY = 'niomon.adminConsoleVisitUrl'
